import React from 'react';
import { withTheme } from 'emotion-theming';
import c from 'classnames';
import * as s from './style';

@withTheme
class AnimateSliderBottom extends React.Component {
  state = {
    closeSlider: false
  };

  closeSlider = () => {
    this.setState(
      {
        closeSlider: true
      },
      () => {
        setTimeout(() => {
          this.props.closeSlider();
        }, 200);
      }
    );
  };

  render() {
    const { theme, className } = this.props;
    const { closeSlider } = this.state;
    return (
      <React.Fragment>
        <div className={c(s.animateSliderBody(theme, closeSlider), className)}>
          {this.props.children}
        </div>
        <div
          className={s.sliderOverlay(theme)}
          onClick={this.closeSlider}
          role="button"
          tabIndex="0"
        />
      </React.Fragment>
    );
  }
}

export default AnimateSliderBottom;
